export default __webpack_public_path__ + "static/media/POPPINS-BOLDITALIC.759f322b.TTF";